import moment from 'moment'

import { isSameDay } from '../../../utils/helpers'
import styles from './DateDivider.module.scss'

const DateDivider = ({ prevMessage, currentMessage }) => {
  const prevDate = prevMessage
    ? (moment().isBefore(prevMessage.deliveryFinishDate)
        ? null
        : prevMessage.deliveryFinishDate) ||
      prevMessage.deliveryStartDate ||
      prevMessage.addedOn
    : null

  const currentDate =
    (moment().isBefore(currentMessage.deliveryFinishDate)
      ? null
      : currentMessage.deliveryFinishDate) ||
    currentMessage.deliveryStartDate ||
    currentMessage.addedOn

  if (isSameDay(prevDate, currentDate)) {
    return null
  } else {
    return (
      <div className={styles.container}>
        <div className={styles.divider}>
          <span>{moment(currentDate).format('dddd, MMM DD, yyyy')}</span>
        </div>
      </div>
    )
  }
}

export default DateDivider
